import type {FC} from 'react'
import {useParams} from 'react-router'
import {useQuery} from 'react-query'
import {getListRedemptionByMemberId} from '../../../../modules/services/redemption.service'
import {getListTransactionsByMemberId} from '../../../../modules/services/transactions.service'
import {TableDefault} from '../../../../components/ui'
import _ from 'lodash'

const PointHistory: FC = () => {
  const {id} = useParams<{id: string}>()
  const headFields = ['Date', 'Member Name', 'Step', 'Status', 'Point Gain', 'Total Point']
  const bodyFields = [
    'createdAtString',
    'fullname',
    'step',
    'status',
    'reductionPoint',
    'totalPoint',
  ]

  const {data: redemptionData} = useQuery(['redemption', id], () => getListRedemptionByMemberId(id))
  const redemptions =
    (redemptionData?.data as Array<any>)?.map((redemption) => ({
      step: 'Redemption',
      fullname: redemption.attributes.member?.data.attributes.fullname,
      totalPoint: redemption.attributes.totalPoint,
      createdAt: new Date(redemption.attributes.createdAt),
      createdAtString: new Date(redemption.attributes.createdAt).toLocaleString(),
      status: redemption.attributes.status,
      reductionPoint: redemption.attributes.reductionPoint,
    })) || []

  const {data: transactionData} = useQuery(['transaction', id], () =>
    getListTransactionsByMemberId(id)
  )
  const transactions =
    (transactionData?.data as Array<any>)?.map((transaction) => ({
      step: 'Transaction',
      fullname: transaction.attributes.Member?.data.attributes.fullname,
      totalPoint: 0,
      createdAt: new Date(transaction.attributes.createdAt),
      createdAtString: new Date(transaction.attributes.createdAt).toLocaleString(),
      status: transaction.attributes.Status,
      reductionPoint: transaction.attributes.TotalPoint,
    })) || []

  // concat redemption and transaction
  let pointHistories = _.sortBy([...redemptions, ...transactions], 'createdAt')
  // console.log(pointHistories, 'pointHistories')
  let dataPoint: any[] = []
  pointHistories.forEach((pointHistory, index) => {
    if (index === 0) {
      dataPoint.push(pointHistory)
    } else {
      if (pointHistory.step == 'Transaction') {
        pointHistory.totalPoint =
          parseInt(dataPoint?.[index - 1]?.totalPoint) + parseInt(pointHistory.reductionPoint)
      }
      return dataPoint.push(pointHistory)
    }
  })
  //reverse pointHistories
  pointHistories = pointHistories.reverse()
  return (
    <div className='row'>
      <TableDefault
        head={headFields}
        body={bodyFields}
        data={pointHistories}
        isWithAction={false}
      />
    </div>
  )
}

export default PointHistory
